import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { injectIntl, defineMessages } from 'react-intl'
import { compose } from 'recompose'
import {
  loadGroup,
  clearGroup,
} from '../../common/groups/actions'
import { PageHeader, GuideMessage, BackLink, EmptyList } from '../components'

class GroupDetailPage extends React.Component {
  componentDidMount() {
    this.props.loadGroup(this.props.match.params.id)
  }

  componentWillUnmount() {
    this.props.clearGroup()
  }

  render() {
    const { currentGroup, viewer, intl } = this.props

    if (!currentGroup) return null

    return (
      <div>
        <BackLink />
        <PageHeader
          title={`${intl.formatMessage(messages.class)}: ${currentGroup.name}`}
        />
        <h3 className="float-left">
          {intl.formatMessage(messages.students)}:
        </h3>
        <div className="test-lessons-list flex-column">
          {
            currentGroup.students.length ?
              currentGroup.students.map(student => (
                <div className="item-box" key={student.id}>
                  <Link to={`/app/student/${student.id}`}>
                    <h4>{student.name}</h4>
                  </Link>
                  {
                    student.lastTest &&
                    <p>
                      <Link to={`/app/result/${student.lastTest.resultId}`}>
                        {intl.formatMessage(messages.lastTest)} ({student.lastTest.testName}):
                         {student.lastTest.percentage} %
                      </Link>
                    </p>
                  }
                </div>
              ))
            :
              <EmptyList
                title={intl.formatMessage(messages.noStudents)}
              />
          }
        </div>
      </div>
    )
  }
}

GroupDetailPage.defaultProps = {
  currentGroup: null,
  viewer: null,
  match: null,
}

GroupDetailPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadGroup: PropTypes.func.isRequired,
  clearGroup: PropTypes.func.isRequired,
  currentGroup: PropTypes.object,
  viewer: PropTypes.object,
  match: PropTypes.object,
}

const enhance = compose(
  connect(state => ({
    currentGroup: state.groups.currentGroup,
    viewer: state.users.viewer,
  }), { clearGroup, loadGroup }),
  injectIntl,
)

export default enhance(GroupDetailPage)

const messages = defineMessages({
  class: {
    id: 'groupDetail.page.class',
    defaultMessage: 'Trieda',
  },
  students: {
    id: 'groupDetail.page.students',
    defaultMessage: 'Študenti',
  },
  lastTest: {
    id: 'groupDetail.page.lastTest',
    defaultMessage: 'Posledný test',
  },
  noStudents: {
    id: 'groupDetail.page.noStudents',
    defaultMessage: 'Zatiaľ nie su pridaný v tejto triede žiadny študenti.',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/GroupDetailPage.js